import React, { Component } from 'react';
import {baseUrl} from '../../url';
import moment from 'moment';

class KFT extends Component{
    state = {
        type: 'e/u/cr',
        serum_sodium: '',
        potassium: '',
        chloride: '',
        bicarbonates: '',
        urea_bun: '',
        creatinine: '',
        date: '',
        success: false,
        response: true,
    }
    handleChange = (e) =>{
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });
        if(e.target.name === 'date'){
            let date  = moment(e.target.value).format('YYYY-MM-DD HH:mm:ss')
            this.setState({
                date
            })
        }
    }
    close = () => {
        setTimeout(() => { 
            this.props.handleClose();
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {type, date , serum_sodium, potassium , chloride, bicarbonates, urea_bun, creatinine} = this.state;

        if(!date){
            this.setState({
                dateError: 'Please enter a valid date'
            })
        }
        if(!serum_sodium){
            this.setState({
                serum_sodiumError: 'This field cannot be empty'
            })
        }
        if(!potassium){
            this.setState({
                potassiumError: 'This field cannot be empty'
            })
        }
        if(!chloride){
            this.setState({
                chlorideError: 'This field cannot be empty'
            })
        }
        if(!bicarbonates){
            this.setState({
                bicarbonatesError: 'This field cannot be empty'
            })
        }
        if(!urea_bun){
            this.setState({
                urea_bunError: 'This field cannot be empty'
            })
        }
        if(!creatinine){
            this.setState({
                creatinineError: 'This field cannot be empty'
            })
        }
        if( type && date && serum_sodium && potassium && chloride && bicarbonates && urea_bun && creatinine){
            this.setState({
                response: false
            })
            const token = localStorage.getItem('access_token');
            const id = localStorage.getItem('user_id');
            let retries = 0;
            let entry = {
                'treatment_date': date,
                type,
                serum_sodium,
                potassium,
                chloride,
                bicarbonates,
                urea_bun,
                creatinine
            };

            fetch(`${baseUrl}/admin/patients/tests/${id}`,{
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': token,
                },
                body: JSON.stringify(entry)
            })
            .then(response => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then(responseJson => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                   if(responseJson._meta._status === 202){
                       this.setState({
                           success: true,
                           message: responseJson.message
                       }, () => {
                           this.props.hideField();
                           this.props.refresh();
                           this.close();
                       })
                   }
                }
            })
            .catch((error) => {
                if (error === 401 && retries < 1) {
                    localStorage.getItem('access_token')
                        .then(value => {
                            fetch(`${baseUrl}/token/refresh`, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': value
                                }
                            }).then(response => {
                                retries += 1;
                                if (response.status === 200) {
                                    localStorage.setItem('access_token', response.headers.get('Authorization'));
                                    this.handleSubmit();
                                }
                                else {
                                    alert('something went wrong please try again later');
                                }
                            })
                        })
                }
                else {
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    render(){
        const {success} = this.state;
        return(
            <React.Fragment>
                {
                    !success &&
                    <React.Fragment>
                        <label>
                            Date test was taken
                            <input type="date" onChange={this.handleChange} name="date" className={this.state.dateError ? 'error-input' : ''} />
                            <span className="error-text">{this.state.dateError}</span>
                        </label>
                        <label>
                            Serum Sodium
                            <input type="number" onChange={this.handleChange} name="serum_sodium" className={this.state.serum_sodiumError ? 'error-input' : ''} />
                            <span>mmol/L</span>
                            <span className="regular">Normal Range 135-155</span>
                            <span className="error-text">{this.state.serum_sodiumError}</span>
                        </label>
                        <label>
                            Potassium
                            <input type="number" step="0.1" onChange={this.handleChange} name="potassium" className={this.state.potassiumError ? 'error-input' : ''} />
                            <span>mmol/L</span>
                            <span className="regular">Normal Range 3.4-5.3</span>
                            <span className="error-text">{this.state.potassiumError}</span>
                        </label>
                        <label>
                            Chloride
                            <input type="number" onChange={this.handleChange} name="chloride" className={this.state.chlorideError ? 'error-input' : ''} />
                            <span>mmol/L</span>
                            <span className="regular">Normal Range 96-100</span>
                            <span className="error-text">{this.state.chlorideError}</span>
                        </label>
                        <label>
                            Bicarbonates
                            <input type="number" onChange={this.handleChange} name="bicarbonates" className={this.state.bicarbonatesError ? 'error-input' : ''} />
                            <span>mmol/L</span>
                            <span className="regular">Normal Range 21-30</span>
                            <span className="error-text">{this.state.bicarbonatesError}</span>
                        </label>
                        <label>
                            Urea (BUN)
                            <input type="number" step="0.1" onChange={this.handleChange} name="urea_bun" className={this.state.urea_bunError ? 'error-input' : ''} />
                            <span>mmol/L</span>
                            <span className="regular">Normal Range 2.9-8.2</span>
                            <span className="error-text">{this.state.urea_bunError}</span>
                        </label>
                        <label>
                            Creatinine
                            <input type="number" step="0.01" onChange={this.handleChange} name="creatinine" className={this.state.creatinineError ? 'error-input' : ''} />
                            <span>mmol/L/24hrs</span>
                            <span className="regular">Normal Range 8.84-26.5</span>
                            <span className="error-text">{this.state.creatinineError}</span>
                        </label>
                        <button onClick={this.handleSubmit}>
                            Save
                            {
                                !this.state.response &&
                                <i className="fa fa-spinner fa-pulse fa-fw" />
                            }
                        </button>
                    </React.Fragment>
                }
                {
                    this.state.success &&
                    <div className="check">
                        <div className="svg-div">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </div>
                        <p><small>{this.state.message}</small></p>
                    </div> 
                }
            </React.Fragment>
        )
    }
}

export default KFT;


// WEBPACK FOOTER //
// ./src/components/patientProfile/testForms/kft.js